import { FunctionalComponent, h } from '@stencil/core';
import state from '@ugc-store';
import { PageType } from '@ugc-utils/utils';

const ViewMobile: FunctionalComponent<{ productId: number }> = ({ productId }) => {
  const { isQnaLoading, qids, isQnaLoaded, isFirstLoad } = state;
  const isFirstEmpty = qids.length === 0 && isQnaLoaded && isFirstLoad;

  return (
    <div class="ugc-global-css-wrap">
      <div class="ugc-pdp-qna-section ugc-component-wrap relative">
        {isQnaLoading && <ugc-loading />}

        {!isFirstEmpty && (
          <div class="bg-white p-16">
            <div class="mb-12">
              <ugc-page-summary pageType={PageType.qna} productId={productId} />
            </div>

            <ugc-qna-ask-question data-testid="pdp-qna-ask-question" />
            <ugc-qna-filter productId={productId} />
          </div>
        )}

        <ugc-qna-list productId={productId} />
        <ugc-qna-no-data />
        <ugc-qna-scroll-ga />
        <ugc-qna-sort-filter-modal />
        <ugc-qna-ask-question-modal />
        <ugc-qna-answer-modal />
        <ugc-qna-view-more-answers-modal />
      </div>
    </div>
  );
};

export default ViewMobile;
